import "./src/components/layout.css";
import "highlight.js/styles/github-dark.css";

import ReactDOM from "react-dom/client";

export const replaceHydrateFunction = () => {
  return (element: React.ReactNode, container: Element | DocumentFragment) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};
